import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Radio, Row, Select } from 'antd';
import styles from './employment-details.module.less';
import {
	EMPLOYER_TYPE_OPTIONS,
	EMPLOYMENT_TYPE_CODE,
	OCCUPATION_LISTS,
	ONBOARDING_CURRENCY_TYPE,
	OTHER_VALUE_TYPE
} from 'src/constants';
import CountryDistrictSection from 'src/components/country-district-section/country-district-section';
import TitleBox from 'src/components/title-box/title-box';
import { useTranslation } from 'react-i18next';
import { i18nKey } from 'src/locales/i18n';
import { IIndividualBorrowerOnboardingStore } from 'src/store/user/individual-borrower-onboarding.store';
import useStore from 'src/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { IApplicationStore } from 'src/store/root/application.store';
import NumberInput from 'src/components/input-with-number/input-with-number';
import { normalizeInputBlockNumber } from 'src/helpers/common.utils';
import { ZIPCODE_REGEX } from 'src/constants/validation';

const EmploymentDetails = () => {
	const [t] = useTranslation();
	const [form] = Form.useForm();
	const [disableZipCode, setDisableZipCode] = useState(false);
	const [isRequrieFillInfo,setRequireFillInfo] = useState<boolean>(true);
	const onboardStore: IIndividualBorrowerOnboardingStore = useStore('individualBorrowerOnboardingStore');

	const applicationStore: IApplicationStore = useStore('applicationStore');

	const renderEmployerType = () => {
		if (onboardStore.employmentDetail?.employerType === OTHER_VALUE_TYPE.OTHERS_VALUE) {
			return (
				<>
					<Col xs={12} sm={12} md={12} lg={12}>
						<Form.Item required={isRequrieFillInfo} label={`${t(i18nKey.onboarding.request.employment.employerType)}`}>
							<Row gutter={10}>
								<Col span={12}>
									<Form.Item noStyle name="employerType">
										<Select placeholder={`${t(i18nKey.common.select)}`} options={EMPLOYER_TYPE_OPTIONS} />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item name="employerTypeOther">
										<Input />
									</Form.Item>
								</Col>
							</Row>
						</Form.Item>
					</Col>
				</>
			);
		}
		return (
			<>
				<Col xs={24} sm={24} md={24} lg={12}>
					<Form.Item name="employerType" required={isRequrieFillInfo} label={`${t(i18nKey.onboarding.request.employment.employerType)}`}>
						<Select placeholder={`${t(i18nKey.common.select)}`} options={EMPLOYER_TYPE_OPTIONS} />
					</Form.Item>
				</Col>
			</>
		);
	};

	const renderOccupation = () => {
		if (onboardStore.employmentDetail?.occupation === OTHER_VALUE_TYPE.OTHERS_VALUE) {
			return (
				<>
					<Col xs={12} sm={12} md={12} lg={12}>
						<Form.Item required={isRequrieFillInfo} label={`${t(i18nKey.onboarding.request.employment.occupation)}`}>
							<Row gutter={10}>
								<Col span={12}>
									<Form.Item noStyle name="occupation">
										<Select placeholder={`${t(i18nKey.common.select)}`} options={OCCUPATION_LISTS} />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item name="occupationOther">
										<Input />
									</Form.Item>
								</Col>
							</Row>
						</Form.Item>
					</Col>
				</>
			);
		}

		return (
			<>
				<Col xs={24} sm={24} md={24} lg={12}>
					<Form.Item required={isRequrieFillInfo} name="occupation" label={`${t(i18nKey.onboarding.request.employment.occupation)}`}>
						<Select placeholder={`${t(i18nKey.common.select)}`} options={OCCUPATION_LISTS} />
					</Form.Item>
				</Col>
			</>
		);
	};

	useEffect(() => {
		if (!form.isFieldsTouched()) {
			form.setFieldsValue({
				...onboardStore.employmentDetail,
				currency: onboardStore.employmentDetail?.currency
					? onboardStore.employmentDetail?.currency
					: ONBOARDING_CURRENCY_TYPE.HKD
			});
			if (onboardStore.employmentDetail && onboardStore.employmentDetail?.country === 'HK') {
				setDisableZipCode(true);
			}
		}
	}, [onboardStore.employmentDetail]);

	useEffect(()=>{
		if(onboardStore.employmentDetail?.employerType === EMPLOYMENT_TYPE_CODE.retired){
			setRequireFillInfo(false)
		}
		else{
			setRequireFillInfo(true)
		}
	

	},[onboardStore.employmentDetail])


	return (
		<>
			<Form
				form={form}
				layout="vertical"
				disabled
				initialValues={{
					...onboardStore.employmentDetail,
					currency: onboardStore.employmentDetail?.currency
						? onboardStore.employmentDetail?.currency
						: ONBOARDING_CURRENCY_TYPE.HKD
				}}>
				<TitleBox>
					<span>{t(i18nKey.mortgageDeal.requestForm.borrowerRequest.EmploymentDetails)}</span>
				</TitleBox>
				<div className={styles.subForm}>
					<Row style={{ width: '100%' }}>
						<Col span={onboardStore.employmentDetail?.employmentType === EMPLOYMENT_TYPE_CODE.others ? 21: 24}>
						<Form.Item
							style={{ width: '100%' }}
							name="employmentType"
							label={`${t(i18nKey.onboarding.request.employment.employmentType)}`}
							required={true}
							rules={[
								{
									required: true,
									message: `${t(i18nKey.onboarding.validation.required)}`
								}
							]}>
							<Radio.Group size="large" className={styles.radioSpace}>
							<Radio value={EMPLOYMENT_TYPE_CODE.employed}>
											{t(i18nKey.onboarding.request.employment.employed)}
										</Radio>
										<Radio value={EMPLOYMENT_TYPE_CODE.selfEmployed}>
											{t(i18nKey.onboarding.request.employment.selfEmployed)}
										</Radio>
										<Radio value={EMPLOYMENT_TYPE_CODE.retired}>
											{t(i18nKey.onboarding.request.employment.retired)}
										</Radio>
										<Radio style={{ marginTop: '15px' }} value={EMPLOYMENT_TYPE_CODE.others}>
												{t(i18nKey.onboarding.request.employment.others)}
											</Radio>
								
							</Radio.Group>
							{onboardStore.employmentDetail?.employmentType === EMPLOYMENT_TYPE_CODE.others && (
												<Col span={3}>
													<Form.Item name="employmentTypeOther" noStyle>
														<Input />
													</Form.Item>
												</Col>
											)}
						</Form.Item>
						</Col>
					</Row>
					<Row gutter={[32, 16]}>
						<Col span={24}>
							<Form.Item
								name="employmentStatus"
								label={`${t(i18nKey.onboarding.request.employment.employmentStatus)}`}
								required={isRequrieFillInfo}
								rules={[
									{
										required: true,
										message: `${t(i18nKey.onboarding.validation.required)}`
									}
								]}>
								<Radio.Group className={styles.radioSpace}>
									<Radio value={'fulltime'}>{t(i18nKey.onboarding.request.employment.esFullTime)}</Radio>
									<Radio value={'partTime'}>{t(i18nKey.onboarding.request.employment.esPartTime)}</Radio>
									<Radio value={'contract'}>{t(i18nKey.onboarding.request.employment.esContract)}</Radio>
									<Radio value={'casual/temp'}>{t(i18nKey.onboarding.request.employment.esCasualTemp)}</Radio>
								</Radio.Group>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[32, 16]}>
						<Col xs={24} sm={24} md={24} lg={12}>
							<Form.Item
								name="employerName"
								label={`${t(i18nKey.onboarding.request.employment.employerName)}`}
								required={isRequrieFillInfo}
								rules={[
									{
										required: true,
										message: `${t(i18nKey.onboarding.validation.required)}`
									}
								]}>
								<Input />
							</Form.Item>
						</Col>
						{renderEmployerType()}
					</Row>
					<Row gutter={[32, 16]}>
						<Col xs={24} sm={24} md={24} lg={12}>
							<Form.Item
								name="natureOfBusiness"
								label={`${t(i18nKey.onboarding.request.employment.natureOfBiz)}`}
								required={isRequrieFillInfo}
								normalize={normalizeInputBlockNumber}
								rules={[
									{
										required: true,
										message: `${t(i18nKey.onboarding.validation.required)}`
									}
								]}>
								<Input />
							</Form.Item>
						</Col>
						{renderOccupation()}
					</Row>
					<Row gutter={[32, 16]}>
						<Col xs={24} sm={24} md={24} lg={12}>
							<Form.Item required={isRequrieFillInfo} label={`${t(i18nKey.onboarding.request.employment.employerPhone)}`}>
								<Row gutter={[16, 16]}>
									<Col xs={9} sm={9} md={6} lg={11} xl={9} xxl={7}>
										<Form.Item
											noStyle
											name={'employerPhoneExtension'}
											required={false}
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}>
											<Select
												placeholder={`${t(i18nKey.common.select)}`}
												options={applicationStore.phoneCountryCode}
												showSearch
												filterOption={(input, option) =>
													(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
												}
											/>
										</Form.Item>
									</Col>
									<Col xs={15} sm={15} md={18} lg={13} xl={15} xxl={17}>
										<NumberInput
											name="employerPhone"
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}
										/>
									</Col>
								</Row>
							</Form.Item>
						</Col>
						<Col xs={24} sm={24} md={24} lg={12}>
							<Form.Item
								name="annualSalary"
								label={`${t(i18nKey.onboarding.request.employment.annualSalary)}`}
								required={isRequrieFillInfo}
								normalize={(c, p) => {
									if (!c) {
										return '';
									}
									const newValue = Number(c);

									if (isNaN(newValue)) {
										return p || '';
									}
									return c;
								}}
								rules={[
									{
										required: true,
										message: `${t(i18nKey.onboarding.validation.required)}`
									}
								]}>
								<Input />
							</Form.Item>
						</Col>
					</Row>
					<div className={styles.subLevelForm}>
						<Row gutter={[32, 16]}>
							<Col span={24}>
								<Row>
									<Col span={24} className={styles.titleName}>
										{t(i18nKey.onboarding.request.employment.employersAddress)}
									</Col>
								</Row>
								<Row>
									<Col span={24}>
										<div className={styles.dividerLine}></div>
									</Col>
								</Row>

								<Row gutter={[32, 16]}>
									<Col span={24}>
										<Form.Item
											name="addressLine"
											label={`${t(i18nKey.dashboard.accountInformation.adrLine)}`}
											required={isRequrieFillInfo}
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}>
											<Input />
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={[32, 16]}>
									<Col span={24}>
										<Form.Item
											name="street"
											label={`${t(i18nKey.dashboard.accountInformation.street)}`}
											required={isRequrieFillInfo}
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}>
											<Input />
										</Form.Item>
									</Col>
								</Row>
								<CountryDistrictSection
									countryName={'country'}
									countryLabel={`${t(i18nKey.dashboard.accountInformation.country)}`}
									countryRules={[
										{
											required: true,
											message: `${t(i18nKey.onboarding.validation.required)}`
										}
									]}
									districtName={'district'}
									districtLabel={`${t(i18nKey.dashboard.accountInformation.district)}`}
									districtRules={[
										{
											required: true,
											message: `${t(i18nKey.onboarding.validation.required)}`
										}
									]}
									requireCountry={isRequrieFillInfo}
									requireDistrict={isRequrieFillInfo}
								/>
								{!disableZipCode && (
									<Row gutter={[32, 16]}>
										<Col span={24}>
											<Form.Item
												name="zipCode"
												label={`${t(i18nKey.dashboard.accountInformation.zipCode)}`}
												required={isRequrieFillInfo}
												rules={[
													{
														required: true,
														message: `${t(i18nKey.onboarding.validation.required)}`
													},
													{
														pattern: ZIPCODE_REGEX,
														message: `${t(i18nKey.onboarding.validation.zipCode)}`
													}
												]}>
												<Input />
											</Form.Item>
										</Col>
									</Row>
								)}
							</Col>
						</Row>
					</div>
				</div>
			</Form>
		</>
	);
};

export default observer(EmploymentDetails);
